// THIS PLACE IS A PRISON — world config (design/cellblock.html). Data only; the
// engine is RoomEngine. 'q' = the regime board (rounds), 'z' = the table
// (standings) — wall-mounted "?" info spots you inspect but don't step on.
import type { WorldConfig } from './world';

export const prisonWorld: WorldConfig = {
  wrapperClass: 'pworld',
  menuTitle: 'THE BLOCK',
  roomVoice: 'ON THE LANDING',

  rooms: {
    wing: {
      name: 'D WING',
      floor: 'WING',
      map: [
        '#####q##',
        '#.DD...#',
        '#..c...1',
        '#......1',
        '#.....z#',
        '#B.B.B.#',
        '#n.n.n.#',
        '########',
      ],
      exits: {
        '1': { to: 'yard', r: 1, c: 6, face2: 'd', kind: 'door', face: 'r', glyph: '▶', name: 'OUT TO THE YARD' },
      },
      entry: [3, 5],
      npc: { '1,2': 'A', '6,1': 'B', '6,3': 'C' },
      blurb: 'Your landing. The warden has the drop box and the cell doors are open, for now.',
    },
    yard: {
      name: 'THE YARD',
      floor: 'YARD',
      map: [
        'FFFFFF11FFFFFFF',
        'FyyyyyyyyyyyyyO',
        'FyyLLLLLLLLyyyF',
        'FyyLyyyyyyyLyyF',
        '4yyLyyygyyyLyyF',
        '4yyLyyyyyyyLyyF',
        'FyyLLLLLLLLyyyF',
        'FyGyyyyyyyyyyyF',
        'FyyyPyyyyyyyyyF',
        'FF22FFFF33FFFFF',
        'FFFFFFFFFFFFFFF',
      ],
      exits: {
        '1': { to: 'wing', r: 3, c: 5, face2: 'l', kind: 'door', face: 'u', glyph: '▲', name: 'BACK TO D WING' },
        '2': { to: 'mess', r: 5, c: 13, face2: 'l', kind: 'door', face: 'd', glyph: '▼', name: 'THROUGH TO THE MESS' },
        '3': { to: 'hole', r: 2, c: 6, face2: 'd', kind: 'stair', face: 'd', glyph: '▼', name: 'DOWN TO THE HOLE' },
        '4': { route: '/chat', kind: 'door', face: 'l', glyph: '◀', name: 'THE HUDDLE BY THE WALL' },
      },
      entry: [7, 7],
      npc: { '3,4': 'D', '7,9': 'E', '8,4': 'F' },
      blurb: 'Painted lines, one tower, and forty minutes. Everybody talks out here.',
    },
    mess: {
      name: 'THE MESS',
      floor: 'MESS',
      map: [
        '##WWW#####WWW##',
        '#VVVVVV.VVVVVV#',
        '#.............#',
        '#.===..===..==#',
        '#.EEE..EEE..EE#',
        '#.............2',
        '#.............2',
        '#.===..===..==#',
        '#.EEE..EEE..EE#',
        '#......p......#',
        '###############',
      ],
      exits: {
        '2': { to: 'yard', r: 8, c: 2, face2: 'u', kind: 'door', face: 'r', glyph: '▶', name: 'BACK TO THE YARD' },
      },
      entry: [5, 13],
      npc: { '2,4': 'G', '9,10': 'H' },
      blurb: 'Long tables, cold servery, and the only room where everyone sits down at once.',
    },
    hole: {
      name: 'THE HOLE',
      floor: 'HOLE',
      map: [
        '#############',
        '#####33######',
        '#III.....III#',
        '#kkkkkkkkkkk#',
        '#kkkkkkkkkkk#',
        '#kkkkkvkkkkk#',
        '#kkkkkkkkkkk#',
        '#III.....III#',
        '#############',
      ],
      exits: {
        '3': { to: 'yard', r: 8, c: 8, face2: 'u', kind: 'stair', face: 'u', glyph: '▲', name: 'UP TO THE YARD' },
      },
      entry: [2, 6],
      npc: {},
      blurb: 'Six doors, no windows, and a light that stays on. Somebody goes down here each week.',
    },
  },

  spots: {
    c: { key: 'c', name: 'THE DROP BOX', sub: 'Hand your track to the warden', route: '/submit', phase: 'SUBMITTING', doneField: 'submitted', shut: 'Sealed. Submissions are closed.' },
    g: { key: 'g', name: 'THE LINE-UP', sub: 'Name who submitted what', route: '/guess', phase: 'VOTING', doneField: 'guesses_done', shut: 'Not open yet. Wait for voting.' },
    p: { key: 'p', name: 'SENTENCING', sub: 'Spend your points', route: '/vote', phase: 'VOTING', doneField: 'points_done', shut: 'Not open yet. Wait for voting.' },
    v: { key: 'v', name: 'THE HOLE', sub: 'Send one track down', route: '/veto', phase: 'VOTING', doneField: 'veto_done', shut: 'Not open yet. Wait for voting.' },
  },

  info: {
    q: { key: 'q', name: 'THE REGIME', sub: 'Every round, scheduled and served.', route: '/rounds' },
    z: { key: 'z', name: 'THE TABLE', sub: 'Who is up, who owes. The standings.', route: '/standings' },
  },

  cls: {
    '#': 'w', '.': 'conc', y: 'yard', L: 'line', k: 'dark', B: 'bars', n: 'cellin',
    F: 'fence', O: 'tower', D: 'desk', G: 'rack', P: 'plates', V: 'serv', '=': 'mtable', E: 'bench', W: 'bwin', I: 'iso',
  },
  walk: new Set(['.', 'y', 'L', 'k']),
  floor: { wing: 'conc', yard: 'yard', mess: 'conc', hole: 'dark' },
  npcSlots: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],

  palette: {
    id: 'prison',
    disc: '#6d7f68',
    pal: { '1': '#0d1310', '2': '#2b3a2c', '3': '#a9bda2' },
    palMe: { '1': '#0d1310', '2': '#2b3a2c', '3': '#dff0d8' },
  },

  // Unkind, passive-aggressive — the prison voice never warms up (spec §7).
  npcLines: [
    'Bold submission. Bold.',
    'I heard yours. I had questions.',
    'Somebody is getting vetoed. Read the room.',
    'You paid money for that track, did you.',
    'It is a choice. I will leave it there.',
    'Strong round. For everyone else.',
    'I gave you a point. Do not spend it all at once.',
    'We all clapped. We did not mean it.',
    'Not everyone gets taste. You are proof.',
    'Keep your head down and your track quieter.',
    'Interesting, if you enjoy being wrong.',
    'You will be fine. Statistically, someone has to be.',
  ],

  flavor: {
    B: { title: 'A CELL', text: 'Door open, nobody home. They filed early.' },
    n: { title: 'A CELL', text: 'Door open, nobody home. They filed early.' },
    I: { title: 'ISOLATION', text: 'Steel, a hatch, and a light that never goes off.' },
    F: { title: 'THE WIRE', text: 'Twelve foot and turned in at the top. Nobody is going over it.' },
    O: { title: 'THE TOWER', text: 'Somebody up there is paid to watch you pick songs.' },
    D: { title: 'THE DESK', text: 'Clipboard, kettle, and a list with all your names on it.' },
    V: { title: 'THE SERVERY', text: 'Cold. Always cold.' },
    '=': { title: 'THE TABLES', text: 'Bolted down. Everything in here is bolted down.' },
    E: { title: 'THE TABLES', text: 'Bolted down. Everything in here is bolted down.' },
    W: { title: 'A WINDOW', text: 'Barred, and facing a wall.' },
    G: { title: 'THE WEIGHTS', text: 'Bolted to the ground like everything else. Somebody has chalked a tally on the upright.' },
    P: { title: 'LOOSE PLATES', text: 'Left out. Nobody is putting them back.' },
  },

  menuLinks: [
    { label: 'THE REGIME', sub: 'Rounds scheduled and served', route: '/rounds' },
    { label: 'THE HUDDLE', sub: 'By the yard wall', route: '/chat' },
    { label: 'SWITCH VENUE', sub: 'Back to the door', route: '/style', ex: true },
  ],

  // Slow, mellow, minor — Am–F–C–G, a cold institutional lullaby.
  jukebox: {
    root: 110,
    chords: [[0, 3, 7], [-4, 0, 3], [3, 7, 10], [-2, 2, 5]],
    beatMs: 460,
    wave: 'triangle',
    gain: 0.1,
  },

  // Static scenes (spec §27). 'voted' shows during VOTING, 'unvoted' during
  // SUBMITTING — the tableau reflects the round's state, never lies about it.
  scenes: [
    {
      id: 'dispute',
      room: 'mess',
      requires: 'voted',
      actors: { '4,4': 'dadrock', '4,7': 'professor' },
      lines: [
        'DAD ROCK: nine minutes is not a song, it is a commute.',
        'THE PROFESSOR: it is a suite. There is a difference.',
        'DAD ROCK: there is not.',
        'THE PROFESSOR: I will write it down for you.',
      ],
    },
    {
      id: 'laps',
      room: 'yard',
      requires: 'voted',
      actors: { '7,11': 'onebpm' },
      lines: ['ONE BPM has done eleven laps without speaking to anybody.', 'He is building to something.'],
    },
    {
      id: 'conspiracy',
      room: 'wing',
      requires: 'unvoted',
      actors: { '6,1': 'onebpm', '6,3': 'nostalgia' },
      lines: [
        'NOSTALGIA: are you doing yours tonight?',
        'ONE BPM: are you?',
        'NOSTALGIA: I asked first.',
        'Neither of them has filed anything. Two days left.',
      ],
    },
  ],

  // Animated scene (spec §34): Ryan on the bar by the rack, cycling two poses.
  patrols: [
    {
      id: 'weights',
      room: 'yard',
      requires: 'voted',
      ms: 600,
      cast: [{ k: 'ryanlift0', role: 'hold', at: [8, 2], frames: ['ryanlift0', 'ryanlift1'] }],
      lines: [
        'RYAN has not spoken to anybody in forty minutes.',
        'The bar is the only thing on this wing nobody argues about.',
        'Nobody knows where the bandana came from.',
        'RYAN: two more.',
        'He said that eleven minutes ago.',
      ],
    },
  ],
};
